import { getMailMenuItemShouldHideForMailbox } from "owa-mail-filterable-menu-behavior";
import type { MailboxInfo } from "owa-client-types";
import { type MenuItemType } from "owa-filterable-menu/lib/components/MenuItemType";
import { getReadRibbonId } from "./getReadRibbonId";
import { owaComputedFn } from "owa-computed-fn";
import { type MailRibbonControlId } from "owa-ribbon-ids/lib/mailRibbonId";
import { stack, type VerticalControlStack } from "owa-acui";
import type { ClientItemId } from "owa-client-ids";

export const getIgnoreBlockReportStack: (mailboxInfo: MailboxInfo, itemId: ClientItemId | undefined) => VerticalControlStack | string = owaComputedFn(function getIgnoreBlockReportStack(mailboxInfo: MailboxInfo, itemId: ClientItemId | undefined): VerticalControlStack | string {
    const controlsToDisplay: string[] = [];
    
    if (!getMailMenuItemShouldHideForMailbox(54, mailboxInfo)) {
        controlsToDisplay.push(getReadRibbonId(531, itemId).toString());
    }
    
    if (!getMailMenuItemShouldHideForMailbox(5, mailboxInfo)) {
        controlsToDisplay.push(getReadRibbonId(658, itemId).toString());
    }
    
    // For MLR stacks, we always want 3 items in the stack, so we add a null item if there are only 2
    if (controlsToDisplay.length === 1) {
        return controlsToDisplay[0];
    }
    else {
        return stack(controlsToDisplay[0], controlsToDisplay[1], controlsToDisplay.length === 2 ? null : controlsToDisplay[2]);
    }
});
